import React, { useEffect, useState } from 'react';
import { FieldWithLabel } from '@hoc/withClass';
import { FormFieldProps } from '../Form/Form';
import './checkbox-field.scss';
import classNames from 'classnames';

export interface CheckboxFieldProps extends FormFieldProps {
    linkable?: boolean;
    alignCheckboxRight?: boolean;
    getFalseValueOnUnchecked?: boolean; // hidden input is used to get "false" value for the unchecked field, but there are two checkbox fields with the same name in form processed by FormData
}

const CheckboxField = ({
    name,
    checked = false,
    linkable = false,
    onChange,
    style,
    alignCheckboxRight = false,
    testId,
    getFalseValueOnUnchecked = true,
    ...props
}: CheckboxFieldProps) => {
    const [checkedState, setChecked] = useState<boolean>(checked);

    useEffect(() => {
        setChecked(checked);
    }, [checked]);

    const onChangeHandler = e => {
        setChecked(e.target.checked);
        onChange?.(e);
    };

    const formFieldClassNames = classNames(
        'form-field-md',
        alignCheckboxRight && 'form-field-md_align-right'
    );

    const className = classNames(linkable && 'checkbox-field_link');

    return (
        <div
            className={formFieldClassNames}
            style={style?.minWidth ? { minWidth: style?.minWidth } : {}}
        >
            {getFalseValueOnUnchecked ? (
                <input
                    type="hidden"
                    name={name}
                    value="false"
                    hidden={props.hidden}
                    disabled={props.disabled}
                />
            ) : null}
            <input
                type="checkbox"
                name={name}
                className={className}
                value="true"
                checked={checkedState}
                onChange={onChangeHandler}
                {...(testId ? { 'data-testid': testId } : {})}
                {...props}
            />
        </div>
    );
};

const Labeled = FieldWithLabel<CheckboxFieldProps>(CheckboxField);

export { Labeled };

export default CheckboxField;
